import { useEffect, useMemo, useRef } from "react";
import GTM from "../../GTM";
import PropTypes from "prop-types";

function NoRecords({
    message,
    className = "",
    timestamp = null,
    page,
    label,
    attribute1,
    attribute3,
}) {
    const ref = useRef(null);
    const gtm = useMemo(() => new GTM(null), []);

    useEffect(() => {
        gtm.Event(
            page,
            "field level error",
            "error",
            label,
            attribute1,
            "",
            attribute3,
            `${
                message ??
                "no records found, please review your search criteria and try again."
            }`
        );
    }, [timestamp, attribute1, attribute3, label, gtm, message, page]);

    return (
        <div
            className={"alert notify-norecords py-20p " + className}
            ref={ref}
            tabIndex={-1}
        >
            <p className="alert-section">
                <label className="icon-notify" style={{ minWidth: "1.5rem" }}>
                    i
                </label>

                <span>
                    {message ??
                        "No records found, please review your search criteria and try again."}
                </span>
            </p>
        </div>
    );
}

NoRecords.propTypes = {
    message: PropTypes.string,
    className: PropTypes.string,
    timestamp: PropTypes.string,
    page: PropTypes.string,
    label: PropTypes.string,
    attribute1: PropTypes.string,
    attribute3: PropTypes.string,
};

export default NoRecords;
